import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { motion } from "framer-motion";

import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";

import ConsentManager from "@/modules/frontend/components/ConsentManager";
import PopUp from "@/modules/frontend/components/PopUp";
import BookADemo from "@/modules/frontend/components/BookADemo";
import { ToastContainer } from "react-toastify";
import ourProductImg1 from "@/assets/images/webp/our-product-img-1.webp";
import ourProductImg2 from "@/assets/images/webp/our-product-img-2.webp";

import bedgeStarterImg from "@/assets/images/webp/bedge-starter.webp";
import bedgeStandardImg from "@/assets/images/webp/bedge-standard.webp";
import bedgePremiumImg from "@/assets/images/webp/bedge-premium.webp";
import bedgePremiumPlusImg from "@/assets/images/webp/bedge-premium-plus.webp";

import bedgeEliteImg from "@/assets/images/webp/bedge-elight.webp";
import bedgeProImg from "@/assets/images/webp/bedge-pro.webp";
import bedgePlusImg from "@/assets/images/webp/bedge-plus.webp";
import bedgeBasicImg from "@/assets/images/webp/bedge-basic.webp";
import { publicRoutePaths } from "@/routes/public.routes.config";



const Index = () => {

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  const [smallmodalShow, setSmallModalShow] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("en");

  const handleQuoteClick = () => {
    setSmallModalShow(true);
  };

  useEffect(() => {
    setSelectedLanguage(localStorage.getItem("web_lang"));
  }, []);

  return (
    <section className="our-products">
      <SeoHelmet
        title={seoConfig.ourProducts.title}
        description={seoConfig.ourProducts.description}
        keywords={seoConfig.ourProducts.keywords}
        author={seoConfig.ourProducts.author}
      />
      <button
        className="btn outline small sticky-btn"
        onClick={handleQuoteClick}
        type="button"
      >
        Book A Demo
      </button>
      {/* inner banner wrape START  */}
      <div className="inner-banner">
        <div className="container">
          {
            selectedLanguage === "en" ? <div className="content-wrape desk-hide">
              <h2>
                <motion.span className="light animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.1}
                  variants={fadeUpVariant}>Memberships that</motion.span>
                <motion.span className="blue-text animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                > Move Your</motion.span>
                <motion.span className="black animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                > Business Forward</motion.span>
              </h2>
              <motion.p
                className="animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                custom={0.1}
                variants={fadeUpVariant}
              >Gain access to verified partners, strategic insights and recognition programs designed for global business success.</motion.p>
            </div> : <div className="content-wrape desk-hide">
              <h2>
                <span className="light">Memberships that</span>
                <span className="blue-text"> Move Your</span>
                <span className="black"> Business Forward</span>
              </h2>
              <p
                className=""
              >Gain access to verified partners, strategic insights and recognition programs designed for global business success.</p>
            </div>}
        </div>
      </div>
      {/* inner banner wrape END  */}

      {/* inner page content START */}
      <div className="inner-page-content-wrape our-product-page">
        <div className="container introduction">
          {
            selectedLanguage == "en" ? <div className="content-wrape mobile-show page-head">
              <h2 className="mobile-head-text">
                <motion.span className="light animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                >Memberships that</motion.span>
                <motion.span className="blue-text animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                > Move Your</motion.span>
                <motion.span className="black animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                > Business Forward</motion.span>
              </h2>
              <motion.p className="animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                custom={0.1}
                variants={fadeUpVariant}
              >Gain access to verified partners, strategic insights and recognition programs designed for global B2B success.</motion.p>
            </div> : <div className="content-wrape mobile-show page-head">
              <h2 className="mobile-head-text">
                <span className="light">Memberships that</span>
                <span className="blue-text"> Move Your</span>
                <span className="black"> Business Forward</span>
              </h2>
              <p className="">Gain access to verified partners, strategic insights and recognition programs designed for global B2B success.</p>
            </div>
          }
          <div className="row">
            <div className="col-xxl-3"></div>
            <div className="col-xxl-6">
              <div className="head-text">
                <motion.h2 className="head mb-4 animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                >
                  Accelerate Your Trade with Purpose-Driven Memberships
                </motion.h2>
                <br />
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12'>
              <div className='img-wrape'>
                <Link to={publicRoutePaths.REGISTRATION.path} href={publicRoutePaths.REGISTRATION.path} target="_blank" >
                  <motion.img src={ourProductImg1} alt='Our Product' loading="lazy"
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  ></motion.img>
                </Link>

              </div>
            </div>
            <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex align-items-center'>
              <div className='content-wrape'>
                <motion.p className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                >Orex Trade offers flexible Annual Membership Plans designed to meet the unique needs of buyers, suppliers and logistics partners in the global business network. Each plan is crafted to provide maximum value, combining access to verified trade partners, digital promotion tools, logistics support and advanced business insights.</motion.p>

                <motion.p className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                >Whether you’re looking to expand your network, generate high-quality leads or grow your international trade operations, our memberships give you the tools and support to succeed. Explore our plans to choose the right level of engagement and unlock opportunities for business growth, credibility and global reach.</motion.p>
                <br />

                <div className="small-img d-flex justify-content-end">
                  <motion.img src={ourProductImg2} alt='Our Product' loading="lazy"
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  ></motion.img>
                </div>
              </div>
            </div>
          </div>
        </div>


        {/* membership plan Wrape START */}
        <div className="membership-plan-wrape">
          <div className="container">
            <div className="row">
              <div className="col-xxl-2"></div>
              <div className="col-xxl-8">
                <div className="head-text center">
                  <motion.h2 className="head center animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >
                    Membership Plans
                  </motion.h2>
                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >Flexible Membership Plans Designed to Accelerate Your Growth Within the Global Business Network, Unlock New Trade Opportunities, Enhance Credibility and Maximize Business Potential.</motion.p>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              {/* <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 text-center">
                <motion.img src={bedgeStarterImg} alt='Starter' loading="lazy"
                  className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                ></motion.img>
              </div> */}
              <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 text-center">
                <motion.img src={bedgeStandardImg} alt='Starter' loading="lazy"
                  className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                ></motion.img>
              </div>
              <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 text-center">
                <motion.img src={bedgePremiumImg} alt='Starter' loading="lazy"
                  className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.1}
                  variants={fadeUpVariant}></motion.img>
              </div>
              <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 text-center">
                <motion.img src={bedgePremiumPlusImg} alt='Starter' loading="lazy"
                  className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                ></motion.img>
              </div>
            </div>
          </div>
        </div>
        {/* membership plan Wrape END */}

        {/* partner criteria wrape START */}
        <div className="criteria-wrape">
          <div className="container">
            <div className="row">
              <div className="col-xxl-2"></div>
              <div className="col-xxl-8">
                <div className="head-text center">
                  <motion.h2 className="head center animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >
                    PARTNER RECOGNITION CRITERIA
                  </motion.h2>
                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >Highlighting businesses that consistently demonstrate excellence, integrity, verified performance and a proven track record in reliable, secure global trade.</motion.p>
                </div>
              </div>
            </div>

            <div className="row breck-gap">
              <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6">
                <div className="card">
                  <div className="img-wrape">
                    <motion.img src={bedgeEliteImg} alt='Starter' loading="lazy"
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    ></motion.img>
                  </div>
                  <div className="detail-wrape">
                    <motion.h6 className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Elite Partner</motion.h6>
                    <motion.p
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Companies must have completed 10 or more years of active operations in their respective industry since their establishment.</motion.p>
                  </div>
                  <motion.span className="link animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >
                    <Link to={publicRoutePaths.JOIN_LOGISTIC.path} title="Join as Elite Partner">
                      <i className="arrow"></i>
                    </Link>
                  </motion.span>
                </div>
              </div>
              <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6">
                <div className="card">
                  <div className="img-wrape">
                    <motion.img src={bedgeProImg} alt='Starter' loading="lazy"
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    ></motion.img>
                  </div>
                  <div className="detail-wrape">
                    <motion.h6 className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Pro Partner</motion.h6>
                    <motion.p
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Companies with 5 to 10 years of experience in their respective industry since establishment.</motion.p>
                  </div>
                  <motion.span className="link aimate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >
                    <Link to={publicRoutePaths.JOIN_LOGISTIC.path} title="Join as Pro Partner" >
                      <i className="arrow"></i>
                    </Link>
                  </motion.span>
                </div>
              </div>
              <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6">
                <div className="card">
                  <div className="img-wrape">
                    <motion.img src={bedgePlusImg} alt='Starter' loading="lazy"
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    ></motion.img>
                  </div>
                  <div className="detail-wrape">
                    <motion.h6 className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Plus Partner</motion.h6>
                    <motion.p
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Companies with 2 to 5 years of experience in their respective industry since establishment.</motion.p>
                  </div>
                  <motion.span className="link animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >
                    <Link to={publicRoutePaths.JOIN_LOGISTIC.path} title="Join as Pro Partner">
                      <i className="arrow"></i>
                    </Link>
                  </motion.span>
                </div>
              </div>
              <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6">
                <div className="card">
                  <div className="img-wrape">
                    <motion.img src={bedgeBasicImg} alt='Starter' loading="lazy"
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    ></motion.img>
                  </div>
                  <div className="detail-wrape">
                    <motion.h6
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Basic Partner</motion.h6>
                    <motion.p
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.3 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Companies with 6 months to 2 years of experience in their respective industry since establishment.</motion.p>
                  </div>
                  <motion.span className="link animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >
                    <Link to={publicRoutePaths.JOIN_LOGISTIC.path} title="Join as Basic Partner">
                      <i className="arrow"></i>
                    </Link>
                  </motion.span>
                </div>
              </div>
            </div>

            <br /><br />
            <div className="row">
              <div className="col-xxl-2"></div>
              <div className="col-xxl-8">
                <motion.p className="text-center animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                >This recognition system honors each company whose dedication, expertise and strategic contributions faster trusted connections and drive successful global partnerships.</motion.p>
              </div>
            </div>
          </div>
        </div>
        {/* partner criteria wrape END */}
      </div>
      {/* inner page content END */}
      <ConsentManager data={""} />
      {smallmodalShow && (
        <PopUp
          title="Book A Demo"
          smallmodalShow={smallmodalShow}
          setSmallModalShow={setSmallModalShow}
          className="book-demo"
        // onSubmit={handleRegistrationPopup}
        // okButtonLabel={isDemoUser ? 'GO TO INQUIRIES' : isPreKYCUser ? 'GO TO PROFILE' : isViewer ? 'GO TO INQUIRIES' : isEndUser ? 'GO TO INQUIRIES' : 'REGISTER NOW' 
        // }
        >
          <BookADemo
            setSmallModalShow={setSmallModalShow} />
        </PopUp>
      )}
      <ToastContainer />
    </section>
  );
};

export default React.memo(Index);
